import React from 'react'

type IgnorePanelSwipeProps = {
  children: React.ReactElement
}

export const IgnoreDrawerSwipe: React.FC<IgnorePanelSwipeProps> = ({
  children,
  ...props
}) => {
  const updatedChildren = React.cloneElement(children, {
    ...props,
    ...({ 'data-vaul-no-drag': true } as object),
  })

  return updatedChildren
}
